import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { IconWithLabelComponent } from './icon-with-label.component';

@Component({
  selector: 'hk-caret-button',
  template: `
    <div
      (click)="this.buttonClicked()"
      [ngClass]="{ '!cursor-not-allowed !text-hk_gray-400': this.disabled, '!cursor-pointer !text-black': !this.disabled }"
    >
      <hk-icon-with-label iconClass="ph ph-caret-right" text="{{ text }}"></hk-icon-with-label>
    </div>
  `,
  imports: [NgClass, IconWithLabelComponent],
  standalone: true,
})
export class CaretButtonComponent {
  @Input() public text = '';
  @Input() public disabled = false;
  @Output() clickButton = new EventEmitter<void>();

  public buttonClicked() {
    if (!this.disabled) {
      this.clickButton.emit();
    }
  }
}
